import React from 'react';

const HowItWorksHeader = () => (
  <>
    <h1 className="mb-3 font-serif text-xl text-brand-blue sm:text-4xl">What is First Table?</h1>
    <p className="text-sm leading-normal text-gray-800 sm:text-[19px]">
      <span className="font-bold">
        First Table is a restaurant discovery platform where you get 50% off your meal!
      </span>
      <br />
      Restaurants use First Table to fill empty tables. You pay a small booking fee and enjoy a
      great dining experience at half the price.
    </p>
  </>
);

export default HowItWorksHeader;
